import React, { useContext } from "react";
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Helmet } from "react-helmet-async";
import FormProvider from "../../components/forms/FormProvider";
import SnackbarContext from "../../hooks/notify/snack-bar/snackbar-context";
import { useAuthContext } from "../../auth/useAuthContext";
import PasswordTextField from "../../components/forms/PasswordTextField";
import { AuthLayout } from "../../layouts/AuthLayout";
import LoadingButton from "../../components/forms/LoadingButton";

export default function NewPasswordPage() {
    const { changeFirstPassword } = useAuthContext();
    const snackbarCtx = useContext(SnackbarContext);
    const newSecurePasswordDefaultValue = {
        password: '',
        confirmPassword: ''

    }
    const NewSecurePasswordSchema = Yup.object().shape({
        password: Yup.string().required('Password is required'),
        confirmPassword: Yup.string()
            .required('Confirm password is required')
            .oneOf([Yup.ref('password'), null], 'Passwords must match'),
    });

    const methods = useForm({
        defaultValues: newSecurePasswordDefaultValue,
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
        resolver: yupResolver(NewSecurePasswordSchema)
    });

    const {
        reset,
        setError,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = methods;

    const onSubmit = async (data) => {
        try {
            await changeFirstPassword(data.password);
        } catch (error) {
            snackbarCtx.displayMsg("Error", error.message, "error", 3000);
        }
    }

    return (
      <AuthLayout>
        <Helmet>
          <title>Change Password</title>
        </Helmet>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <PasswordTextField name={'password'} label="Password" placeholder="Enter your password" type={'password'} />
          <PasswordTextField name={'confirmPassword'} label="Confirm password" placeholder="Confirm your password" type={'password'} />
          <div className="flex items-center justify-end mt-4">
            <LoadingButton
              text="Submit"
              loading={isSubmitting}
              type={"submit"}
              classes={"bg-blue-600"}
              onClick={() => {}}
            />
          </div>
        </FormProvider>
      </AuthLayout>
    );
}